import React, {useEffect, useState} from "react";
import BreadCrumb from "Common/BreadCrumb";
import {Container, Row, Col, Card} from "react-bootstrap";
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Navigation, Thumbs} from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import {useLocation} from "react-router-dom";
import {useSearchParams} from "react-router-dom";
import ShoppingInformation from "./ShopingInfo";
import ProductRatting from "./ProductRatting";
import {ToastContainer} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";
import {getProductById as onGetProductById} from "../../../slices/product/thunk";
const url  = process.env.REACT_APP_API_URL;

const ProductDetails = () => {
    document.title = "Details";
    const dispatch = useDispatch<any>();

    const product = createSelector(
        (state: any) => state.Product,
        (brand) => ({
            productData: brand.product
        })
    );
    const {productData} = useSelector(product);
    console.log(productData)

    const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    useEffect(() => {
        if (id) {
            dispatch(onGetProductById(id));
        }
    }, [dispatch]);

    return (
        <React.Fragment>
            {(Object.keys(productData).length > 0 && id) ? (
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Product Overview" pageTitle="Product"/>
                        <Row>
                            <Col xxl={4}>
                                <Card className="p-3 sticky-side-div">
                                    <div className="product-img-slider">
                                        <Swiper
                                            thumbs={{swiper: thumbsSwiper}}
                                            navigation={true}
                                            modules={[FreeMode, Navigation, Thumbs]}
                                            spaceBetween={15}
                                            autoplay={{delay: 2500, disableOnInteraction: false}}
                                            className="swiper product-thumbnail-slider p-2 rounded bg-light"
                                        >
                                            {
                                                (productData.images || [])?.map((item: any) => {
                                                    return (
                                                        <SwiperSlide key={item.id} style={{width: "452px"}}>
                                                            <div className="p-5 mx-4">
                                                                <img src={url + item.url} alt=""
                                                                     className="img-fluid d-block"/>
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                })
                                            }
                                        </Swiper>
                                        <Swiper
                                            onSwiper={setThumbsSwiper}
                                            slidesPerView={4}
                                            freeMode={true}
                                            watchSlidesProgress={true}
                                            spaceBetween={10}
                                            className="swiper product-nav-slider mt-2 swiper-initialized swiper-horizontal swiper-free-mode swiper-watch-progress swiper-backface-hidden swiper-thumbs"
                                        >
                                            <div className="swiper-wrapper">
                                                {
                                                    (productData.images || [])?.map((item: any) => {
                                                        return (
                                                            <SwiperSlide className="rounded" key={item.id}>
                                                                <div className="nav-slide-item">
                                                                    <img
                                                                        src={url + item.url}
                                                                        alt=""
                                                                        className="img-fluid d-block rounded"
                                                                    />
                                                                </div>
                                                            </SwiperSlide>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </Swiper>
                                    </div>
                                </Card>
                            </Col>
                            <ShoppingInformation productData={productData}/>
                        </Row>
                        <ProductRatting classname="flex-shrink-0" productData={productData}/>
                    </Container>
                </div>
            ) : (
                <div className="page-content">
                    <Container fluid>
                        <Row id="categoryList">
                            <Col lg={12}>
                                <Card>
                                    <Card.Body className="mt-3">
                                        <div id="noresult">
                                            <div className="text-center py-4">
                                                <div className="avatar-md mx-auto mb-4">
                                                    <div
                                                        className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                        <i className="bi bi-search"></i>
                                                    </div>
                                                </div>
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}

            <ToastContainer/>
        </React.Fragment>
    );
}

export default ProductDetails;